module.exports = __webpack_public_path__ + "img/awards_image_12.cd201596.jpg";